import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledSearchButton, EditorToggleBlock } from './search-button.styles';
import EditorToggleIcon from '@icons/toggle-icon';
import EditorToggleActiveIcon from '@icons/toggle-active-icon';
import SourceIcon from '@icons/editor/source-icon';

const EditorButton = ({ isMobile, cookie }) => {
  const [state, dispatch] = useContext(Context);
  return (
    cookie ? (
    <StyledSearchButton
      onClick={() => {
        dispatch({ type: 'TOGGLE_EDITOR_MODAL' });
      }}
      title="Режим конспектирования"
    >
      {state.isEditorSidebarOpened ? (
        <EditorToggleBlock>
          <i><SourceIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /></i> <EditorToggleActiveIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /> <span>Режим<br/>конспектирования</span> 
        </EditorToggleBlock>
      ) : (
        <EditorToggleBlock>
          <i><SourceIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /></i> <EditorToggleIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /> <span>Режим<br/>конспектирования</span> 
        </EditorToggleBlock>
      )}
    </StyledSearchButton> )
    : ( <StyledSearchButton
      onClick={() => {
        dispatch({ type: 'SHOW_EDITOR_COOKIE', payload: true});
        //dispatch({ type: 'TOGGLE_EDITOR_MODAL' });
      }}
      title="Режим конспектирования"
    >
      {state.isEditorCookieOpened ? (
        <EditorToggleBlock>
          <i><SourceIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /></i> <EditorToggleActiveIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /> <span>Режим<br/>конспектирования</span> 
        </EditorToggleBlock>
      ) : (
        <EditorToggleBlock>
           <i><SourceIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /></i> <EditorToggleIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} /> <span>Режим<br/>конспектирования</span>  
        </EditorToggleBlock>
      )}
    </StyledSearchButton> )
  );
};

export default EditorButton;